const applyListItemSelectorOverride = function (isProductPage, rp$) {
    if (isProductPage || typeof igViewOnVehicleSettings === 'undefined') {
        return false;
    }

    igViewOnVehicleSettings.listItemSelector = rp$('.catalog-product-card').length > 0
        ? '.catalog-product-card'
        : '.catalog-product';

    return true;
};

const getDealerCode = function (rp$) {
    const dealerCodeFromButton = rp$('.find-dealer-button[data-ig-dealer-code]').attr('data-ig-dealer-code');
    if (typeof dealerCodeFromButton === 'string' && dealerCodeFromButton.length > 0) {
        return dealerCodeFromButton;
    }

    const dealerCodeFromVehicle = rp$('.ig-vov-vehicle[data-ig-dealer-code]').attr('data-ig-dealer-code');
    if (typeof dealerCodeFromVehicle === 'string' && dealerCodeFromVehicle.length > 0) {
        return dealerCodeFromVehicle;
    }

    const igUrl = rp$('.ig-view-on-vehicle-wrapper[data-ig-url]').attr('data-ig-url');
    if (typeof igUrl === 'string') {
        const dealerCodePattern = /\/(ig\d+)\/?$/i;
        const match = dealerCodePattern.exec(igUrl);
        if (match) {
            return match[1];
        }
    }

    return null;
};

const clearSettingsWaitInterval = function (settingsWaitState) {
    if (settingsWaitState.intervalId !== null) {
        clearInterval(settingsWaitState.intervalId);
        settingsWaitState.intervalId = null;
    }
};

const initializeInteractiveGarage = function (rp$, targetViewType) {
    const igSettings = typeof igViewOnVehicleSettings === 'undefined' ? undefined : igViewOnVehicleSettings;
    if (typeof rp$.igViewOnVehicle === 'function') {
        rp$.igViewOnVehicle(targetViewType, getDealerCode(rp$), igSettings);
        return;
    }

    // Fallback to global igViewOnVehicle if rp-scoped function is not available
    if (typeof igViewOnVehicle === 'function') {
        igViewOnVehicle(targetViewType, getDealerCode(rp$), igSettings);
    }
};

const initializeWithSettingsWait = function (
    targetViewType,
    isProductPage,
    rp$,
    settingsWaitState
) {
    clearSettingsWaitInterval(settingsWaitState);

    if (targetViewType !== 'list') {
        initializeInteractiveGarage(rp$, targetViewType);
        return;
    }

    if (applyListItemSelectorOverride(isProductPage, rp$)) {
        initializeInteractiveGarage(rp$, targetViewType);
        return;
    }

    const maxAttempts = 50; // 5 seconds
    const interval = 100; // 100ms
    let attempts = 0;
    settingsWaitState.intervalId = setInterval(function () {
        attempts += 1;

        if (applyListItemSelectorOverride(isProductPage, rp$) || attempts >= maxAttempts) {
            clearSettingsWaitInterval(settingsWaitState);
            initializeInteractiveGarage(rp$, targetViewType);
        }
    }, interval);
};

const handleSearchResultsResponse = function (rp$, isProductPage, settingsWaitState) {
    setTimeout(function () {
        initializeWithSettingsWait('list', isProductPage, rp$, settingsWaitState);
    }, 1);
};

const removeBodyOverlaySpinner = function (rp$) {
    const bodyOverlaySpinner = rp$('body').overlaySpinner;
    if (bodyOverlaySpinner !== undefined && typeof bodyOverlaySpinner.remove === 'function') {
        bodyOverlaySpinner.remove();
    }
};

const initializeOnReady = function (rp$, pageIds) {
    const pageId = rp$('.main').attr('id');
    const isProductPage = pageId === pageIds.PRODUCT;
    const viewType = isProductPage ? 'product' : 'list';
    const settingsWaitState = { intervalId: null };

    initializeWithSettingsWait(viewType, isProductPage, rp$, settingsWaitState);

    rp$(document).off('searchResults:response.interactive_garage').on('searchResults:response.interactive_garage', function () {
        handleSearchResultsResponse(rp$, isProductPage, settingsWaitState);
    });

    rp$(document)
        .off('shown.bs.modal.interactive_garage', '#ig_modal')
        .on('shown.bs.modal.interactive_garage', '#ig_modal', function () {
            removeBodyOverlaySpinner(rp$);
        });
};

const THE_SCRIPT = function () {
    const $onReady = require('public/js/lib/on-ready');
    const { PAGE_IDS } = require('public/js/constants/pages');

    $onReady({
        rp$, window,
        label: 'interactive_garage',
        fn: function () {
            initializeOnReady(rp$, PAGE_IDS);
        }
    });
};

try {
    // Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
    if (typeof __CURRENT_SCRIPT__ === 'undefined') {
        throw new Error('__CURRENT_SCRIPT__ is not defined');
    }
    __CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
    THE_SCRIPT();
}